import { Typography } from "@mui/material";
import React from "react";
import { Trans, useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../redux/store";

function BookingSummary() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { voucherAmount, personalData } = useSelector(
    (state: RootState) => state.bookingCreation
  );
  const tenantConfig = useSelector(
    (state: RootState) => state.tenantConfig.config
  );
  return (
    <div className="px-5 text-foreground">
      <div className="flex flex-col gap-2 border-b pb-2">
        <p className="font-medium">
          {t("general.voucher_purchase.summary.title")}
        </p>
        <div className="text-sm">
          <p>{t("general.voucher_purchase.summary.validity")}: 12.06.23</p>
          <p>
            {t("general.voucher_purchase.summary.sent_to")}:{" "}
            {personalData.email}
          </p>
        </div>
        <p className="font-medium">
          {" "}
          {tenantConfig.currencySymbol}
          {voucherAmount}
        </p>
      </div>
      <div className="border rounded-md my-4 p-2 text-sm">
        <p className="font-medium">
          {t("general.voucher_purchase.summary.price_details")}
        </p>
        <div className="flex w-full justify-between">
          <p>{t("general.voucher_purchase.summary.total")}</p>
          <p>
            {" "}
            {tenantConfig.currencySymbol}
            {voucherAmount}
          </p>
        </div>
        <p>{t("general.voucher_purchase.summary.vatNote")}</p>
      </div>

      <div
        className="bg-[#EDF0F5] text-gray-800 p-2 rounded-lg mx-auto"
        style={{
          maxWidth: "100%",
          marginTop: "10px",
          marginBottom: "10px",
        }}
      >
        <Typography>
          <Trans
            i18nKey={"general.voucher_purchase.summary.note"}
            components={{
              bold: (
                <span
                  style={{
                    fontWeight: "bold",
                  }}
                ></span>
              ),
            }}
          />
        </Typography>
      </div>
    </div>
  );
}

export default BookingSummary;
